import { settings } from '../environments/common-settings';

export const environment = Object.assign({
  production: true,
  pollingInterval: 12500,
  updateInterval: 30000,
  apiRoot: 'https://teaching.musictogether.com/_api/v1',
  // apiRoot: 'https://local-teacher.musictogether.com/_api/v1',
  rptpExclusionCollectionPatterns: ['Rhythm Kids', 'bilingue-italiano', 'bilingue-espanol', 'Spanish', 'Italian'],
  sentry: {
    enabled: true,
    dns: 'https://814d5468b02933e23156b3a5ac22fff5@o4506298363019264.ingest.us.sentry.io/4507266253783040',
    traceTargets: ["teaching.musictogether.com", /^https:\/\/teaching\.musictogether\.com\/\_api\/v1/],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  }
}, settings);